'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import * as iiifUtil from '../util/IIIFUtil.js';
import * as domItem from '../viewer/DomItem.js';

const privateMap = util.createPrivateMapper();

export class SceneGroupView extends UiComponent {
  constructor(domEl, options){
    super(domEl);
    const pv = privateMap(this);
    options = options ? options : {};
    pv.componentGenerators = options.componentGenerators ? options.componentGenerators : []
    this.active = false;
  }

  set scenes(argScenes){
    const pv = privateMap(this);
    domUtil.empty(this.domEl);
    this.active = false;
    const scenes = []
    if (!argScenes) {
      return
    }
    for (let s of argScenes) {
      if (!s) {
        continue
      }
      scenes.push(s)
    }
    if (!scenes || !scenes.length) {
      return;
    }
    if (!pv.componentGenerators.length) {
      return
    }
    const ulEl = domUtil.createElement('ul');

    util.each(scenes, (scene) => {
      util.each(pv.componentGenerators, (gen) => {
        const liEl = domUtil.createElement('li')
        const labelEl = domUtil.createElement('h5')
        let label
        if (scene.label && scene.label.text) {
          label = scene.label.text['@none']
        }
        if (!label) {
          label = '-'
        }
        labelEl.appendChild(domUtil.text(label))
        liEl.appendChild(labelEl)

        const bodyEl = domUtil.createElement('div')
        liEl.appendChild(bodyEl)
        gen(bodyEl, scene)

        ulEl.appendChild(liEl)
      })
    })
    this.domEl.appendChild(ulEl);
    this.active = true;
  }
}